import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "onClick"],
    _excluded2 = ["children", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from "react";
import PropTypes from "prop-types";
import { calculateRem } from "@uie/javascript-style-helpers";
import { ModalFooter as CoreModalFooter } from "@vds-core/modals";
import { ButtonGroup } from "@vds/buttons";
var propTypes = {
  /**
   * Primary and Close button data for modal button group
   */
  buttonData: PropTypes.object
};
var defaultProps = {};

var ModalFooter = function ModalFooter(props) {
  var buttonData = props.buttonData,
      viewport = props.viewport,
      children = props.children,
      inverted = props.inverted,
      toggleModal = props.toggleModal;

  var _calculatePadding = function _calculatePadding(mobile) {
    var padding;
    mobile ? padding = calculateRem(47, 0, 16, 1) : padding = calculateRem(47, 0, 4, 2);
    return padding;
  };

  var closeButton = function () {
    if (!buttonData || !buttonData.close) return false;

    var closeModal = function closeModal() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      if (toggleModal && typeof toggleModal === "function") toggleModal();
      action();
    };

    var _buttonData$close = buttonData.close,
        children = _buttonData$close.children,
        _onClick = _buttonData$close.onClick,
        rest = _objectWithoutProperties(_buttonData$close, _excluded);

    return _objectSpread({
      children: children,
      size: "large",
      type: "secondary",
      onClick: function onClick() {
        return closeModal(_onClick);
      },
      noVerticalPadding: true,
      inverted: inverted
    }, rest);
  }();

  var button = function () {
    if (!buttonData || !buttonData.primary) return false;

    var _buttonData$primary = buttonData.primary,
        children = _buttonData$primary.children,
        onClick = _buttonData$primary.onClick,
        rest = _objectWithoutProperties(_buttonData$primary, _excluded2);

    return _objectSpread({
      children: children,
      size: "large",
      type: "primary",
      onClick: onClick || function () {},
      noVerticalPadding: !closeButton,
      inverted: inverted
    }, rest);
  }();

  var buttonArray = [];
  if (button) buttonArray.push(button);
  if (closeButton) buttonArray.push(closeButton);
  var windowWidth = window.innerWidth;
  var mobileQuanity = false;
  if (windowWidth < 767) mobileQuanity = true;
  return /*#__PURE__*/React.createElement(CoreModalFooter, _extends({}, props, {
    footerDisplay: "flex",
    padding: _calculatePadding(mobileQuanity),
    noButtonPadding: true
  }), children, buttonArray && !!buttonArray.length && buttonArray.length > 0 && /*#__PURE__*/React.createElement(ButtonGroup, {
    viewport: viewport,
    rowQuantity: {
      mobile: 1,
      tablet: mobileQuanity ? 1 : 2,
      desktop: mobileQuanity ? 1 : 2
    },
    data: buttonArray
  }));
};

ModalFooter.propTypes = propTypes;
ModalFooter.defaultProps = defaultProps;
export default ModalFooter;